import * as React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Box, IconButton, Typography } from "@mui/material";

import CancelIcon from "@mui/icons-material/Cancel";

export default function SignUpBenefitsModalHeader({ handleClose }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 562,
        height: "80px",
        maxHeight: 256,

        position: "relative",

        backgroundSize: "cover",
        backgroundColor: "#382656",
        backgroundPosition: "center",

        borderRadius: "8px 8px 0px 0px",
      }}
    >
      <Typography
        sx={{
          color: "#FEFEFE",
          position: "absolute",
          top: "24px",
          left: "24px",
        }}
        variant="h5"
      >
        {t("signup")}
      </Typography>
      <IconButton
        onClick={handleClose}
        sx={{
          padding: 0,
          marginBottom: "8px",
          position: "absolute",
          backgroundColor: "white",
          top: "24px",
          right: "24px",
          '&:hover': {
            backgroundColor: "white"
          }
        }}
      >
        <CancelIcon fontSize="large" color="secondary" />
      </IconButton>
    </Box>
  );
}
